import React, { useEffect, useState } from "react";
import BreadCrumbs from "../../components/breadcrumbs";
import Banner from "../../components/img_bannerblogs";
import RCMcy from "../../img/Blogbanners1/How-does-MBSworks/Blogimg.jpg";
import Bannerimg from "../../img/Blogbanners1/How-does-MBSworks/Blogimg.jpg";
import outsourcingCycle from "../../img/Blogbanners1/How-does-MBSworks/oursource-cycle.png";
import BlogImg7 from "../../img/Blogcontent1/whatis-MedicalBilling-Process/Medical-Billingprocess-Blog.jpg";
import Blogimg1 from "../../images/BlogCardImgs/Guide-for-Medicalbilling.jpg";
import BlogImg3 from "../../img/Blogbanners1/typesOf-MedicalBillingBlogCard.jpg";
import BlogImg2 from "../../images/BlogCardImgs/choosingtooutsourceyourmedicalbillingisasmartdecision1.webp";
import BlogImg15 from "../../images/BlogCardImgs/7Common-Reasons-for_Claim-Denials_in_the_U.S..jpg";
import BlogImg16 from "../../images/BlogCardImgs/detailsaboutpatientsareprotectedbyacer1.webp";
import BlogImg4 from "../../img/Blogbanners1/Medicalcover.jpg";


import { Helmet } from "react-helmet";
import "../../css/testcard.css";
import Tablecontent from "../Blogs/Blogstablecontent";

import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardImage,
    MDBCardTitle,
    MDBCardText,
    MDBCardBody,
} from "mdb-react-ui-kit";

const About = () => {
    useEffect(() => {
        // change title of page
        document.title = "How Does Medical Billing Outsourcing Work? | Step-by-Step Guide ";
    }, []);

    // Set Banner Title
    const [BannerTitle, setBannerTitle] = useState({
        title: "How Does Medical Billing Outsourcing Work? A Step-by-Step Guide",
        subtitle: "",
        img: `url(${Bannerimg})`,
        alt: "Medical billing outsourcing workflow showing insurance verification, claims, denial management, payment posting, A/R follow-up, and revenue cycle reporting."
    });
    const tableHeaderStyle = {
        padding: '10px',
        border: '1px solid black',
        textAlign: 'center',
        backgroundColor: '#f2f2f2',
    };

    const tableCellStyle = {
        padding: '10px',
        border: '1px solid black',
        textAlign: 'center',
    };
    const data2 = [

        { col1: <b>Eligibility</b>, col2: 'Verify insurance coverage and benefits' },
        { col1: <b>Coding</b>, col2: 'Review documentation and assign appropriate codes' },
        { col1: <b>Claims</b>, col2: 'Prepare, validate, and submit claims' },
        { col1: <b>Denials</b>, col2: 'Review denied claims, make corrections, and handle appeals' },
        { col1: <b>Payment Posting</b>, col2: 'Record payer payments, adjustments, and patient balances' },
        { col1: <b>A/R</b>, col2: 'Follow up on outstanding and underpaid claims' },
        { col1: <b>Reporting</b>, col2: 'Track billing performance and provide revenue cycle reports' }

    ];
    const data = [

        { col1: <b>Staffing</b>, col2: 'The practice hires, trains, and manages its own billing staff.', col3: 'The billing company provides and manages the billing team.' },
        { col1: <b>Technology</b>, col2: 'The practice is responsible for billing software, systems, and related tools.', col3: 'The outsourcing partner works with the required billing technology and system connections.' },
        { col1: <b>Expertise</b>, col2: 'Knowledge and experience depend on the skills of the internal billing team.', col3: 'The practice gains access to professionals with specialized revenue cycle experience.' },
        { col1: <b>Scalability</b>, col2: 'The practice must adjust staffing and resources as billing volume changes.', col3: 'Billing resources can be adjusted based on workload and service requirements.' },
        { col1: <b>Administrative Workload</b>, col2: 'Practice leadership oversees billing staff, processes, training, and performance.', col3: 'The outsourcing partner manages much of the day-to-day billing administration.' },
        { col1: <b>Cost Structure</b>, col2: 'Expenses include employee salaries, benefits, technology, training, and operational costs.', col3: 'Costs are generally based on the outsourced services and agreed pricing structure.' },
        { col1: <b>Management Responsibility</b>, col2: 'The practice directly manages the billing operation and staff.', col3: 'The practice manages the relationship and reviews performance while the billing partner handles assigned tasks.' },


    ];

    return (
        <>
            <Helmet>
                <style>{`body { overflow-x: hidden; }`}</style>
                <title>How Does Medical Billing Outsourcing Work? | Step-by-Step Guide </title>
                <meta
                    name="description"
                    content="Learn how medical billing outsourcing works, from onboarding and insurance verification to coding, claim submission, denial management, payment posting, A/R follow-up, and reporting."
                />
                <link
                    rel="canonical"
                    href="https://acerhealth.com/blog/how-does-medical-billing-outsourcing-work"
                />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Article",
                        "@id": "https://acerhealth.com/blog/how-does-medical-billing-outsourcing-work#article",
                        "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": "https://acerhealth.com/blog/how-does-medical-billing-outsourcing-work"
                        },
                        "headline": "How Does Medical Billing Outsourcing Work? A Step-by-Step Guide",
                        "description": "Learn how medical billing outsourcing works, from onboarding and insurance verification to coding, claim submission, denial management, payment posting, A/R follow-up, and reporting.",
                        "inLanguage": "en-US",
                        "author": {
                            "@type": "Organization",
                            "name": "AcerHealth"
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": "AcerHealth",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://acerhealth.com/assets/images/logo.png"
                            }
                        },
                        "image": {
                            "@type": "ImageObject",
                            "url": "https://acerhealth.com/blog/how-does-medical-billing-outsourcing-work/cover-image.png"
                        },
                        "datePublished": "2026-09-17",
                        "dateModified": "2026-09-17",
                        "articleSection": "Medical Billing, Medical Billing Outsourcing, Revenue Cycle Management",
                        "keywords": [
                            "how does medical billing outsourcing work",
                            "medical billing outsourcing",
                            "medical billing outsourcing process",
                            "medical billing outsourcing services",
                            "medical billing outsourcing workflow",
                            "denial management",
                            "A/R follow-up",
                            "revenue cycle management",
                            "AcerHealth"
                        ],
                        "mainEntity": [
                            {
                                "@type": "Question",
                                "name": "How does medical billing outsourcing work?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Medical billing outsourcing works by transferring selected billing and revenue cycle responsibilities to an external billing team. The billing partner may handle tasks such as insurance verification, coding, claim submission, denial follow-up, payment posting, A/R management, and reporting, while the healthcare practice remains responsible for clinical information, approvals, and oversight."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "What services are included in medical billing outsourcing?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "The services included in medical billing outsourcing depend on the practice’s needs and agreement with the billing partner. Common services include eligibility verification, medical coding, charge capture, claim submission, denial management, payment posting, A/R follow-up, and revenue cycle reporting."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "How does an outsourced billing company handle denied claims?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "When a claim is denied, the billing company reviews the denial reason, identifies what needs to be corrected, and determines the appropriate next step. This may involve correcting claim information, submitting additional documentation, resubmitting the claim, or filing an appeal based on payer requirements."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Can a medical billing company work with our existing EHR?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Yes, many medical billing companies can work with a practice’s existing EHR or practice management system. During onboarding, the billing partner reviews system access, workflows, and clearinghouse connections to make sure billing activities can be managed securely and efficiently."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "How long does it take to transition to outsourced medical billing?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "The transition timeline varies depending on the practice’s size, specialty, systems, payer requirements, and the amount of information being transferred. The process usually includes reviewing current workflows, configuring systems, transferring relevant data, coordinating responsibilities, and preparing for go-live."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Is medical billing outsourcing suitable for small practices?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Medical billing outsourcing can be a practical option for small practices that want access to billing expertise without building and managing a larger internal billing operation. Whether it is a good fit depends on the practice’s workload, specialty, staffing resources, and revenue cycle needs."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "What does a healthcare practice need to do when outsourcing medical billing?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "The practice still needs to provide accurate patient information, complete clinical documentation, respond to billing questions, approve certain workflows, and review performance reports. Outsourcing transfers administrative responsibilities to the billing partner but does not remove the practice’s role in the revenue cycle."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "What happens to outstanding A/R when medical billing is outsourced?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Outstanding A/R can be transferred to the billing partner for continued follow-up. The team reviews unpaid and underpaid claims, contacts payers, works aging accounts, and follows the agreed process to recover outstanding revenue."
                                }
                            }
                        ]
                    }

                    )}
                </script>
            </Helmet>

            <div>
                <Banner BannerTitle={BannerTitle} />
                <div className="container mb-4 mt-4 d-flex">
                    <div style={{ maxWidth: "fit-content", width: "fit-content" }}>
                        <BreadCrumbs
                            paths={[
                                { name: "Home", link: "/" },
                                { name: "Blogs", link: "/medical-billing-blogs" },
                                { name: "How Does Medical Billing Outsourcing Work? " },
                            ]}
                        />
                    </div>
                </div>
                <div className="row" style={{ paddingRight: "10%", paddingLeft: "5%" }}>
                    <MDBCol md="3" className="toc-sticky">
                        <Tablecontent />
                    </MDBCol>

                    <MDBCol md="7" className="content" style={{ paddingRight: "50px" }}>


                        <h1
                            style={{
                                textAlign: "center",
                                fontSize: "30px",
                                fontFamily: "Alegreya Sans",
                            }}
                            className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                        >
                            <b>
                                How Does Medical Billing Outsourcing Work? A Step-by-Step Guide
                            </b>
                        </h1>
                        <div className="mb-3">
                            <img
                                src={RCMcy}
                                alt="Medical billing outsourcing workflow showing insurance verification, claims, denial management, payment posting, A/R follow-up, and revenue cycle reporting."
                                className="img-fluid"
                                width={500}
                                height={500}
                            />
                        </div>
                        <br></br>
                        <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                            style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
                            <b>Introduction</b>
                        </h2>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >Medical billing outsourcing involves moving some or all of a practice’s billing and revenue cycle work to an external billing team.
                            Instead of handling claims, payer follow-up, payment posting, and denials with an entirely in-house staff, the practice relies on
                            a billing partner to manage the administrative side of these activities.

                        </p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            <b>So, how does medical billing outsourcing work? </b>The process usually starts with a review of the practice’s current billing operation.
                            From there, the billing company and practice establish workflows, connect the necessary systems, and determine who is responsible for
                            each part of the process. Depending on the arrangement, the outsourced team may handle insurance verification, coding, claim submission,
                            denial follow-up, payment posting, A/R, and reporting. </p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Outsourcing does not mean the practice steps away from billing altogether. Staff may still need to provide patient and clinical information,
                            answer questions, approve certain decisions, and review billing performance. The difference is that much of the routine administrative
                            work is handled by the external billing team.
                        </p>


                        <br>
                        </br>

                        <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                            style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
                            <b>What Is Medical Billing Outsourcing?</b>
                        </h2>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        > Medical billing outsourcing is when a healthcare practice partners with an external billing team to manage specific billing and revenue cycle
                            activities. Instead of handling every administrative task internally, the practice can transfer responsibilities such as insurance verification,
                            medical coding, claim submission, payment posting, denial follow-up, accounts receivable management, and billing reporting to a specialized team.</p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            The billing partner takes care of the operational side of the <a
                                href="https://acerhealth.com/services/revenue-cycle-management"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                            >
                                revenue cycle
                            </a>revenue cycle, while the healthcare practice continues to manage patient care, clinical decisions, and documentation. To support the process, the practice typically
                            provides access to relevant systems and information, including the EHR, practice management software, payer details, and billing records.</p>
                        <br>
                        </br>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >

                            Medical billing outsourcing is different from simply using billing software. Software can help automate tasks and organize information,
                            but it does not replace the expertise required to review claims, communicate with payers, resolve denials, or follow up on unpaid balances.
                            Outsourcing combines technology with experienced billing professionals who actively manage these processes on behalf of the practice.
                            For practices considering this model, the<a
                                href="https://acerhealth.com/services/revenue-cycle-management"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                            >
                                benefits of medical billing outsourcing
                            </a>can include reduced administrative workload and access to specialized billing support.

                        </p>


                        <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                            style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
                            <b>How Does Medical Billing Outsourcing Work?</b>
                        </h2>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >Medical billing outsourcing works by moving specific billing and revenue cycle responsibilities from the healthcare practice to an external
                            billing team.The
                            <a
                                href="https://acerhealth.com/blog/medical-billing-outsourcing-usa"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                            >
                                medical billing outsourcing process
                            </a> usually covers activities such as onboarding, insurance verification, coding,
                            claim submission, denial management, payment posting, A/R follow-up, and performance reporting.
                        </p>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >The workflow connects the practice, billing partner, payers, and patients throughout the revenue cycle.
                            It begins with understanding the practice’s current operations and continues through claim submission,
                            reimbursement tracking, payment reconciliation, and ongoing performance review.
                        </p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >The process generally follows these stages:
                        </p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        ><b>Assessment and onboarding → eligibility verification → coding and charge capture → claim preparation and submission
                            → claim tracking and denial management → payment posting and reconciliation → A/R follow-up → reporting and performance monitoring</b>
                        </p>
                        <br>
                        </br>
                        <div className="mb-3">
                            <img
                                src={outsourcingCycle}
                                alt="Medical billing outsourcing cycle showing onboarding, eligibility verification, claim submission, denial management, payment posting, A/R follow-up, and reporting."
                                className="img-fluid"
                                width={550}
                                height={500}
                            />
                        </div>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >Each stage plays a role in improving claim accuracy, reducing payment delays, and maintaining a more predictable revenue cycle.       </p>

                        <h3 className="AcerhealthTextPurple fontfamilyAvenir" style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                            <b>1. Initial Assessment and Onboarding</b>    </h3>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Before taking over billing responsibilities, the outsourcing team first needs to understand how the practice currently operates.
                            This includes reviewing the practice’s specialty, existing workflow, EHR or EMR system, payer mix, outstanding accounts receivable
                            (A/R), and current billing challenges.

                            During this stage, both teams establish expectations around responsibilities, communication, reporting, and workflow management.
                            A clear onboarding process helps prevent confusion and creates a smoother transition.
                        </p>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        > During this stage, both teams establish expectations around responsibilities, communication, reporting, and workflow management.
                            A clear onboarding process helps prevent confusion and creates a smoother transition.
                        </p>
                        <br>
                        </br>
                        <h3 className="AcerhealthTextPurple fontfamilyAvenir" style={{ fontSize: "20px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                            <b>2. Patient Registration and Insurance Verification</b>    </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Accurate patient and insurance information forms the foundation of a successful billing process. Before claims are submitted,
                            the billing team verifies demographics, insurance eligibility, benefits, coverage details, and authorization requirements. </p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Identifying coverage issues before services are provided can prevent avoidable denials and reduce delays caused by incorrect or incomplete insurance information. </p>

                        <h3 className="AcerhealthTextPurple fontfamilyAvenir" style={{ fontSize: "19px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                            <b>3. Medical Coding and Charge Capture</b>    </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            After patient services are documented, the billing team reviews the information needed for charge capture and coding.<a
                                href="https://www.cms.gov/cms-guide-medical-technology-companies-and-other-interested-parties/coding/overview-coding-classification-systems"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                            >
                                ICD-10 diagnosis codes,CPT procedure codes, and HCPCS codes
                            </a>  are assigned based on the documentation, while modifiers are reviewed when applicable.   </p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Accurate coding helps ensure that submitted claims correctly represent the services provided and reduces issues that may delay reimbursement. </p>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >Once validated, claims are submitted electronically through the appropriate clearinghouse for payer processing. </p>


                        < h3 className="AcerhealthTextPurple fontfamilyAvenir" style={{ fontSize: "19px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                            <b>5. Claim Tracking and Denial Management</b>    </h3>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Submitting a claim does not complete the billing process. The billing team continues monitoring claim status, payer responses, rejections, and denials.</p>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            When a claim is denied, the team reviews the reason, determines the appropriate correction, and decides whether the claim should be resubmitted or appealed. Tracking recurring
                            denial patterns also helps identify process improvements and strengthen <a
                                href="https://acerhealth.com/blog/denial-management-guide"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                            >
                                denial management
                            </a>  across the billing workflow. </p>


                        < h3 className="AcerhealthTextPurple fontfamilyAvenir" style={{ fontSize: "19px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                            <b>6. Payment Posting and Reconciliation</b>    </h3>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            After the payer processes a claim, payment information is recorded and matched with the corresponding account.
                            <a
                                href="https://www.cms.gov/priorities/key-initiatives/burden-reduction/administrative-simplification/transactions/health-care-payment-remittance-advice-electronic-funds-transfer"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                            >
                                denial management
                            </a>Electronic Remittance Advice (ERA) and Electronic Funds Transfer (EFT) can help streamline payment processing.</p>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            The billing team posts payments, applies contractual adjustments, reviews patient balances, and reconciles
                            expected versus received reimbursement to maintain accurate financial records.</p>

                        < h3 className="AcerhealthTextPurple fontfamilyAvenir" style={{ fontSize: "19px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                            <b>7. A/R Follow-Up and Collections</b>    </h3>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Outstanding claims require continuous attention to prevent revenue delays. The billing team follows up on unpaid and underpaid claims,
                            communicates with insurance payers, investigates payment issues, and manages aging A/R.</p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Consistent A/R follow-up helps recover revenue that may otherwise remain unresolved and gives practices better visibility into their financial performance.</p>

                        < h3 className="AcerhealthTextPurple fontfamilyAvenir" style={{ fontSize: "19px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                            <b>8. Reporting and Performance Monitoring</b>    </h3>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            A successful outsourcing relationship requires ongoing visibility into billing performance. Billing partners provide reports that track important revenue cycle metrics,
                            including denial rates, clean claim rates, A/R days, collections, and payer performance.</p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            These insights help practices understand where revenue is being delayed, identify recurring problems, and make informed decisions about improving their billing operations.</p>

                        <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                            style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
                            <b>What Does a Medical Billing Company Handle?</b>
                        </h2>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            A medical billing company can provide
                            <a
                                href="https://acerhealth.com/services/medical-billing-outsourcing-services-usa"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                            >
                                medical billing outsourcing services
                            </a>
                            that cover many of the administrative tasks involved in managing a healthcare practice’s revenue cycle. Depending on the outsourcing agreement,
                            the billing partner may take responsibility for functions such as eligibility verification, coding, claim submission, denial management,
                            payment posting, A/R follow-up, and revenue cycle reporting.</p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            The exact responsibilities vary from practice to practice. Some organizations outsource only specific billing functions, while others rely on
                            an external team to manage a larger portion of the revenue cycle workflow.</p>

                        <div>
                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                <thead>

                                    <tr>

                                        <th style={tableHeaderStyle}>Billing Function</th>
                                        <th style={tableHeaderStyle}>Outsourced Partner’s Role</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {data2.map((row, index) => (
                                        <tr key={index}>
                                            <td style={tableCellStyle}>{row.col1}</td>
                                            <td style={tableCellStyle}>{row.col2}</td>


                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <br></br>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            The practice may outsource some or all of these functions depending on its operational needs. Additional services, such as insurance follow-up,
                            patient billing support, or authorization assistance, may also be included when they are part of the engagement.</p>



                        <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                            style={{ fontSize: "26px", fontFamily: "Alegreya Sans" }}>
                            <b>What Does the Healthcare Practice Still Need to Do?</b>
                        </h2>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            The healthcare practice remains involved in medical billing outsourcing even after responsibilities are transferred to an external billing team. While the billing partner manages the agreed-upon administrative tasks,
                            the practice still provides the information, approvals, and clinical input needed to keep the billing process accurate.</p>


                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            The practice may still need to:</p>

                        <ul style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", listStyleType: "disc", paddingLeft: "20px" }}>
                            <li>

                                <span><b>Provide accurate patient information </b>— Ensure patient demographics, insurance details, and other required information are complete and updated.</span>
                            </li>
                            <li>

                                <span><b>Complete clinical documentation </b>— Provide timely documentation so services can be coded correctly and supported during the claims process. </span>
                            </li>
                            <li>
                                <span><b>Respond to billing questions </b>— Answer questions from the billing team when additional clinical or practice-specific details are needed. </span>
                            </li>
                            <li>

                                <span><b>Approve certain workflows </b>— Make decisions related to billing policies, write-offs, payment arrangements, or other matters requiring practice approval. </span>
                            </li>
                            <li>

                                <span><b>Communicate about unusual claims  </b>— Provide clarification when a claim involves a complex service, documentation issue, payer request, or situation requiring practice-level input.  </span>
                            </li>
                            <li>

                                <span><b>Review performance reports  </b>— Monitor key revenue cycle metrics such as denials, A/R, collections, and overall billing performance. </span>
                            </li>
                        </ul>


                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Medical billing outsourcing reduces the amount of day-to-day administrative work handled internally, but the practice remains responsible
                            for oversight and collaboration. Clear communication between the practice and billing partner helps ensure issues are addressed quickly
                            and the revenue cycle continues to run efficiently.</p>

                        <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                            style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
                            <b>How Long Does Medical Billing Outsourcing Take to Set Up?</b>
                        </h2>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            <b>There is no fixed timeline for setting up medical billing outsourcing.</b>The transition depends on several factors,
                            including the practice’s size, specialty, current systems, payer relationships, A/R situation, and the range of
                            services being transferred to the billing partner.</p>



                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            Before the outsourced workflow goes live, both teams typically work through several setup stages:</p>


                        <ul style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", listStyleType: "disc", paddingLeft: "20px" }}>
                            <li>

                                <span><b>Initial assessment  </b>— The billing partner reviews the practice’s current billing workflow, specialty requirements, systems, payer mix, outstanding A/R, and operational challenges. </span>
                            </li>
                            <li>

                                <span><b>System configuration  </b>— Required connections between the EHR, practice management system, clearinghouse, reporting tools, and user access are established. </span>
                            </li>
                            <li>

                                <span><b>Data migration </b>— Relevant patient, billing, claims, and A/R information is transferred or made available to the outsourcing team so ongoing work can continue. </span>
                            </li>
                            <li>

                                <span><b>Payer considerations  </b>— The team reviews payer-specific requirements, enrollment details, authorization processes, and clearinghouse connections where needed. </span>
                            </li>
                            <li>

                                <span><b>A/R transfer   </b>— Existing unpaid claims and outstanding accounts are organized so follow-up activities continue without disruption. </span>
                            </li>
                            <li>

                                <span><b>Staff coordination   </b>— The practice and billing partner define responsibilities, communication methods, escalation procedures, and approval workflows.  </span>
                            </li>
                            <li>

                                <span><b>Go-live </b>— Once systems, information, and processes are ready, the outsourced team begins managing the agreed-upon billing responsibilities. </span>
                            </li>
                        </ul>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            The timeline can vary significantly between practices. A smaller practice with straightforward systems may transition more quickly, while larger
                            organizations with multiple specialties, complex payer arrangements, or significant outstanding A/R may require additional preparation.
                            The goal is not simply to move billing tasks quickly, but to create a stable transition with minimal disruption to revenue cycle operations.</p>
                        <br>
                        </br>
                        <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                            style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
                            <b>Medical Billing Outsourcing vs. In-House Billing</b>
                        </h2>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            The difference between medical billing outsourcing and in-house billing comes down to who manages the people, systems, processes, and daily responsibilities
                            involved in revenue cycle operations. With in-house billing, the healthcare practice handles these functions internally. With outsourcing, a billing partner
                            manages the assigned responsibilities while the practice maintains oversight of its billing performance.</p>
                        <div>
                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                <thead>

                                    <tr>

                                        <th style={tableHeaderStyle}>Factor</th>
                                        <th style={tableHeaderStyle}>In-House Billing</th>
                                        <th style={tableHeaderStyle}>Medical Billing Outsourcing </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((row, index) => (
                                        <tr key={index}>
                                            <td style={tableCellStyle}>{row.col1}</td>
                                            <td style={tableCellStyle}>{row.col2}</td>
                                            <td style={tableCellStyle}>{row.col3}</td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <br></br>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            The main difference is <b>operational ownership.</b> With in-house billing, the practice is responsible for building and managing the entire
                            billing operation. With outsourcing, many administrative responsibilities move to an external team, but the practice continues to
                            oversee performance, financial outcomes, and important decisions.</p>



                        <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                            style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
                            <b>Conclusion</b>
                        </h2>
                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >Medical billing outsourcing allows healthcare practices to move selected revenue cycle responsibilities to an external billing team while keeping control
                            over important clinical and operational decisions. Depending on the agreement, the billing partner may manage tasks such as insurance verification,
                            coding, claim submission, denial follow-up, payment posting, A/R management, and reporting.</p>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            A successful outsourcing relationship depends on more than transferring tasks to another company. Clear communication, defined responsibilities,
                            reliable systems, and regular performance reviews help ensure the billing process continues to support the practice’s financial goals. When
                            managed properly, outsourcing can reduce administrative burden while giving practices access to specialized revenue cycle expertise. </p>




                        <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
                            style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
                            <b>Frequently Asked Questions </b>
                        </h2>
                        <br></br>


                        <h3
                            className="AcerhealthTextPurple fontfamilyAvenir"
                            style={{
                                fontSize: "20px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "600",
                            }}
                        >
                            1.  How does medical billing outsourcing work?
                        </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}
                        >
                            <b>Medical billing outsourcing works by transferring selected billing and revenue cycle responsibilities to an external billing team.</b> The billing partner may
                            handle tasks such as insurance verification, coding, claim submission, denial follow-up, payment posting, A/R management, and reporting, while the healthcare
                            practice remains responsible for clinical information, approvals, and oversight.</p>

                        <h3
                            className="AcerhealthTextPurple fontfamilyAvenir"
                            style={{
                                fontSize: "20px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "600",
                            }}
                        >
                            2.	What services are included in medical billing outsourcing?
                        </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}

                        > The services included in medical billing outsourcing depend on the practice’s needs and agreement with the billing partner.
                            Common services include eligibility verification, medical coding, charge capture, claim submission, denial management,
                            payment posting, A/R follow-up, and revenue cycle reporting.</p>


                        <h3
                            className="AcerhealthTextPurple fontfamilyAvenir"
                            style={{
                                fontSize: "20px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "600",
                            }}
                        >
                            3.	How does an outsourced billing company handle denied claims?
                        </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}

                        >When a claim is denied, the billing company reviews the denial reason, identifies what needs to be corrected, and determines the appropriate
                            next step. This may involve correcting claim information, submitting additional documentation, resubmitting the claim, or filing an appeal
                            based on payer requirements.</p>

                        <h3
                            className="AcerhealthTextPurple fontfamilyAvenir"
                            style={{
                                fontSize: "20px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "600",
                            }}
                        >
                            4. Can a medical billing company work with our existing EHR?
                        </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}

                        > Yes, many medical billing companies can work with a practice’s existing EHR or practice management system. During onboarding,
                            the billing partner reviews system access, workflows, and clearinghouse connections to make sure billing activities can be
                            managed securely and efficiently.</p>



                        <h3
                            className="AcerhealthTextPurple fontfamilyAvenir"
                            style={{
                                fontSize: "20px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "600",
                            }}
                        >
                            5.	How long does it take to transition to outsourced medical billing?

                        </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}

                        > The transition timeline varies depending on the practice’s size, specialty, systems, payer requirements, and the amount of information being transferred.
                            The process usually includes reviewing current workflows, configuring systems, transferring relevant data, coordinating responsibilities, and preparing for go-live.</p>

                        <h3
                            className="AcerhealthTextPurple fontfamilyAvenir"
                            style={{
                                fontSize: "20px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "600",
                            }}
                        >
                            6.	Is medical billing outsourcing suitable for small practices?
                        </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}

                        > Medical billing outsourcing can be a practical option for small practices that want access to billing expertise without building and managing a larger internal billing operation.
                            Whether it is a good fit depends on the practice’s workload, specialty, staffing resources, and revenue cycle needs.</p>
                        <h3
                            className="AcerhealthTextPurple fontfamilyAvenir"
                            style={{
                                fontSize: "20px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "600",
                            }}
                        >
                            7.	What does a healthcare practice need to do when outsourcing medical billing?
                        </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}

                        > The practice still needs to provide accurate patient information, complete clinical documentation, respond to billing questions, approve certain workflows, and review performance reports. Outsourcing transfers
                            administrative responsibilities to the billing partner but does not remove the practice’s role in the revenue cycle.</p>


                        <h3
                            className="AcerhealthTextPurple fontfamilyAvenir"
                            style={{
                                fontSize: "20px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "600",
                            }}
                        >
                            8.	What happens to outstanding A/R when medical billing is outsourced?
                        </h3>

                        <p
                            className=""
                            style={{
                                fontSize: "18px",
                                fontFamily: "Alegreya Sans",
                                fontWeight: "500",
                                textAlign: "justify",
                            }}

                        > Outstanding A/R can be transferred to the billing partner for continued follow-up. The team reviews unpaid and underpaid claims, contacts payers,
                            works aging accounts, and follows the agreed process to recover outstanding revenue</p>




                    </MDBCol>
                    <MDBCol md="2" className="content" style={{ padding: "0px" }}>
                        <MDBRow className="row-cols-1 row-cols-md-4 g-4">
                            <MDBCol md="12">
                                <MDBRow>
                                    <MDBCard
                                        className="cardtest1 p-0"
                                        style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                                    >
                                        <MDBCardImage
                                            src={Blogimg1}
                                            alt="Telehealth billing concept showing a smiling doctor on a laptop screen with digital
                 claims floating around, representing modern types of medical billing in a healthcare setting"
                                            position="top"
                                        />
                                        <MDBCardBody>
                                            <div
                                                className="cardtitletest"
                                                style={{
                                                    fontFamily: "Alegreya Sans",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <a href="what-is-medical-billing">
                                                    What Is Medical Billing? A Simple Guide for U.S. Healthcare Practices
                                                </a>
                                            </div>
                                            <MDBCardText>
                                                <small className="text-muted">
                                                    AcerHealth | Feb - 2026
                                                </small>
                                            </MDBCardText>
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBRow>
                            </MDBCol>
                            <MDBCol md="12">
                                <MDBRow>
                                    <MDBCard
                                        className="cardtest1 p-0"
                                        style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                                    >
                                        <MDBCardImage
                                            src={BlogImg3}
                                            alt="Telehealth billing concept showing a smiling doctor on a laptop screen with digital
                 claims floating around, representing modern types of medical billing in a healthcare setting"
                                            position="top"
                                        />
                                        <MDBCardBody>
                                            <div
                                                className="cardtitletest"
                                                style={{
                                                    fontFamily: "Alegreya Sans",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <a href="types-of-medical-billing-and-rcm-impact">
                                                    RCM in Medical Billing: How Different Billing Types Impact Revenue Cycle Management
                                                </a>
                                            </div>
                                            <MDBCardText>
                                                <small className="text-muted">
                                                    AcerHealth | Feb - 2026
                                                </small>
                                            </MDBCardText>
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBRow>
                            </MDBCol>
                            <MDBCol md="12">
                                <MDBRow>
                                    <MDBCard
                                        className="cardtest1 p-0"
                                        style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                                    >
                                        <MDBCardImage
                                            src={BlogImg15}
                                            alt="7 Common Reasons for Claim Denials in the U.S. and How to Prevent Them"
                                            position="top"
                                        />
                                        <MDBCardBody>
                                            <div
                                                className="cardtitletest"
                                                style={{
                                                    fontFamily: "Alegreya Sans",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <a href="claim-denial-reasons-usa">
                                                    7 Common Reasons for Claim Denials in the U.S. and How to Prevent Them
                                                </a>
                                            </div>
                                            <MDBCardText className="pb-4">
                                                <small className="text-muted">
                                                    AcerHealth |  Oct - 2025
                                                </small>
                                            </MDBCardText>
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBRow>
                            </MDBCol>
                            <MDBCol md="12">
                                <MDBRow>
                                    <MDBCard
                                        className="cardtest1 p-0"
                                        style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                                    >
                                        <MDBCardImage
                                            src={BlogImg4}
                                            alt="Details about Patients is Protected by AcerHealth"
                                            position="top"
                                        />
                                        <MDBCardBody>
                                            <div
                                                className="cardtitletest"
                                                style={{
                                                    fontFamily: "Alegreya Sans",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <a href="medical-consultancy-services-benefits">
                                                    What Are Medical Consultancy Services and Why Your Practice Needs Them
                                                </a>
                                            </div>
                                            <MDBCardText className="pb-4">
                                                <small className="text-muted">
                                                    AcerHealth | July - 2025
                                                </small>
                                            </MDBCardText>
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </div>
                <div className="row" style={{ paddingRight: "10%", paddingLeft: "5%" }}>
                    <MDBRow className="row-cols-2 row-cols-md-4 g-4 mb-2">
                        <MDBCol className="d-flex flex-column">
                            <MDBCard
                                className="cardtest1"
                                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
                            >
                                <MDBCardImage
                                    src={BlogImg7}
                                    alt="Digital microchip representing advanced technology and data networks, symbolizing the future trends in medical billing and healthcare technology."
                                    position="top"
                                />
                                <MDBCardBody className="d-flex flex-column">
                                    <div
                                        className="cardtitletest"
                                        style={{
                                            fontFamily: "Alegreya Sans",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <a href="medical-billing-process">
                                            What Is the Medical Billing Process? Procedures, Steps & Workflow Simplified
                                        </a>
                                    </div>
                                    <MDBCardText>
                                        <small className="text-muted">
                                            AcerHealth | Nov - 2025
                                        </small>
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>

                        <MDBCol className="d-flex flex-column">
                            <MDBCard
                                className="cardtest1"
                                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
                            >
                                <MDBCardImage
                                    src={BlogImg2}
                                    alt="Choosing to Outsource Your Medical Billing is a Smart Decision?"
                                    position="top"
                                />
                                <MDBCardBody className="d-flex flex-column">
                                    <div
                                        className="cardtitletest"
                                        style={{
                                            fontFamily: "Alegreya Sans",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <a href="choosing_to_outsource_your_medical_billing_is_a_smart_decision">
                                            Choosing to Outsource Your Medical Billing is a Smart
                                            Decision?
                                        </a>
                                    </div>
                                    <MDBCardText>
                                        <small className="text-muted">
                                            AcerHealth | Aug - 2024
                                        </small>
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>

                        <MDBCol className="d-flex flex-column">
                            <MDBCard
                                className="cardtest1"
                                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
                            >
                                <MDBCardImage
                                    src={BlogImg15}
                                    alt="Management of the Healthcare Revenue Cycle"
                                    position="top"
                                />
                                <MDBCardBody className="d-flex flex-column">
                                    <div
                                        className="cardtitletest"
                                        style={{
                                            fontFamily: "Alegreya Sans",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <a href="claim-denial-reasons-usa">
                                            7 Common Reasons for Claim Denials in the U.S. and How to Prevent Them
                                        </a>
                                    </div>
                                    <MDBCardText>
                                        <small className="text-muted">
                                            AcerHealth | Aug - 2024
                                        </small>
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>

                        <MDBCol className="d-flex flex-column">
                            <MDBCard
                                className="cardtest1"
                                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
                            >
                                <MDBCardImage
                                    src={BlogImg16}
                                    alt="Details about Patients is Protected by AcerHealth"
                                    position="top"
                                />
                                <MDBCardBody className="d-flex flex-column">
                                    <div
                                        className="cardtitletest"
                                        style={{
                                            fontFamily: "Alegreya Sans",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <a href="details_about_patients_is_protected_by_acerhealth">
                                            Details about Patients is Protected by AcerHealth
                                        </a>
                                    </div>
                                    <MDBCardText>
                                        <small className="text-muted">
                                            AcerHealth | Aug - 2024
                                        </small>
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>
                </div>
            </div>
            {/* <DownContact DownContactTitle={DownContactTitle} /> */}
        </>
    );
};

export default About;
